function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo } from 'react';
import { RangeState, RcDateProvider } from '../../../hooks/date';
import { DatePreset } from '../layout/DatePreset';
import { ViewWrapper } from '../units/ViewWrapper';
import { DateContainer } from './DateContainer';
export var DateContentRender = memo(function (props) {
  var parts = props.parts,
      root = props.root,
      _props$enableDragMask = props.enableDragMask,
      enableDragMask = _props$enableDragMask === void 0 ? false : _props$enableDragMask,
      _props$dragMaskSelect = props.dragMaskSelectType,
      dragMaskSelectType = _props$dragMaskSelect === void 0 ? 'cover' : _props$dragMaskSelect,
      _props$enableDragMask2 = props.enableDragMaskReverseMode,
      enableDragMaskReverseMode = _props$enableDragMask2 === void 0 ? false : _props$enableDragMask2,
      className = props.className,
      presets = props.presets,
      onPresetItemClick = props.onPresetItemClick,
      onPresetItemMouseEnter = props.onPresetItemMouseEnter,
      onPresetItemMouseLeave = props.onPresetItemMouseLeave,
      onResetPanel = props.onResetPanel,
      _props$resetOnMouseLe = props.resetOnMouseLeave,
      resetOnMouseLeave = _props$resetOnMouseLe === void 0 ? true : _props$resetOnMouseLe,
      _props$enableInvalidT = props.enableInvalidTooltip,
      enableInvalidTooltip = _props$enableInvalidT === void 0 ? false : _props$enableInvalidT,
      singlePanel = props.singlePanel,
      extra = _objectWithoutProperties(props, ["parts", "root", "enableDragMask", "dragMaskSelectType", "enableDragMaskReverseMode", "className", "presets", "onPresetItemClick", "onPresetItemMouseEnter", "onPresetItemMouseLeave", "onResetPanel", "resetOnMouseLeave", "enableInvalidTooltip", "singlePanel"]);

  var presetNode = React.createElement(DatePreset, {
    presets: presets,
    onPresetItemClick: onPresetItemClick,
    onPresetItemMouseEnter: onPresetItemMouseEnter,
    onPresetItemMouseLeave: onPresetItemMouseLeave
  });
  return React.createElement(DateContainer, Object.assign({}, extra, {
    onResetPanel: onResetPanel,
    resetOnMouseLeave: resetOnMouseLeave,
    preset: presets.length ? presetNode : null
  }), React.createElement("div", {
    className: className
  }, React.createElement(RcDateProvider, {
    root: root
  }, singlePanel && React.createElement(ViewWrapper, {
    part: 'left',
    key: 'left',
    prefix: "date",
    position: RangeState.SINGLE,
    enableDragMask: enableDragMask,
    dragMaskSelectType: dragMaskSelectType,
    enableInvalidTooltip: enableInvalidTooltip,
    enableDragMaskReverseMode: enableDragMaskReverseMode,
    both: true
  }) || parts.map(function (part, index) {
    var position = parts.length === 1 ? RangeState.SINGLE : index === 0 ? RangeState.START : index === parts.length - 1 ? RangeState.END : RangeState.IN;
    return React.createElement(ViewWrapper, {
      part: part,
      key: part,
      prefix: "date",
      position: position,
      enableDragMask: enableDragMask,
      dragMaskSelectType: dragMaskSelectType,
      enableInvalidTooltip: enableInvalidTooltip,
      enableDragMaskReverseMode: enableDragMaskReverseMode
    });
  }))));
});